import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedNotificationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M5.77783 15.5556L6.47502 14.1745C7.03938 13.0565 7.33339 11.8216 7.33339 10.5693V8.66667C7.33339 6.08934 9.42273 4 12.0001 4C14.5774 4 16.6667 6.08934 16.6667 8.66667V10.5693C16.6667 11.8216 16.9607 13.0565 17.5251 14.1745L18.2223 15.5556H5.77783Z",
			stroke: "#4B7987",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9998 20C13.3175 20 14.3857 18.9318 14.3857 17.614L9.61381 17.614C9.61381 18.9318 10.682 20 11.9998 20Z",
			fill: "#4B7987"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedNotificationIcon);
const Memo = memo(ForwardRef);
export default Memo;
